const descMenu = {   
    advert: document.getElementById('advertWrap') as HTMLElement,
    advertWrap: document.querySelectorAll('.jsCopyAdvert') as NodeListOf<HTMLElement>,
    infoAdvert: document.getElementById('headerInfo') as HTMLElement,
    triger: document.getElementById('openSubMenu') as HTMLElement,
    menu: document.getElementById('subMenu') as HTMLElement,

    init() {
        if(window.innerWidth > 1200) {
            this.setImg();
            this.toggleMenu();
            this.clickOutside();
        }
        
    },
    toggleMenu() {
        this.triger.addEventListener('click', (e)=>{           
            this.menu.classList.toggle('activeClass');
        })
    },
    clickOutside() {
        window.addEventListener('click', (e) => {   
            const targetEl = e.target as HTMLElement;    
            if (this.triger.contains(targetEl) || this.menu.contains(targetEl)) {
             
                return
              
            }
            this.menu.classList.remove('activeClass');
           

         })
    },
    setImg() {        
        this.advertWrap.forEach(item=>{
            const title = item.dataset.advert as string;
            const className = '.' + title.replaceAll(/\s/g, '.');
            const advert = this.advert.querySelector(className) as HTMLElement || null;
            
            if(advert) {
                const img = advert.dataset.img as string
                advert.style.backgroundImage = `url(${img})`;
               
                const advDiv =  document.createElement('div');
                advDiv.classList.add('nav-desc__advert-img');
                advDiv.innerHTML = advert.outerHTML;
                item.appendChild(advDiv);

                const infoDiv = document.createElement('div');
                infoDiv.classList.add('nav-desc__info');
                infoDiv.innerHTML = this.infoAdvert.innerHTML;
                item.appendChild(infoDiv)
            }
        })   
    }

}

export default descMenu;